import "react";
import { Button as f } from "./button.esm.79d8737f.js";
import { jsx as u } from "./utils.esm.ea524c19.js";
function d({
  children: n,
  className: t,
  href: r,
  onClick: e,
  title: o
}) {
  return r ? /* @__PURE__ */ u("a", {
    children: n,
    className: `bw-link${t ? ` ${t}` : ""}`,
    href: r,
    onClick: e,
    rel: "noopener noreferrer",
    target: "_blank",
    title: o
  }) : /* @__PURE__ */ u("button", {
    children: n,
    className: `bw-link${t ? ` ${t}` : ""}`,
    onClick: e,
    title: o
  });
}
const i = ({
  className: n,
  style: t,
  type: r = "primary",
  title: e,
  label: o,
  onClick: b,
  loading: p,
  disabled: $
}) => /* @__PURE__ */ u(f, {
  className: `bw-button p-button-rounded p-button-${r}${n ? ` ${n}` : ""}`,
  style: t,
  title: e || o,
  label: o,
  onClick: b,
  loading: p,
  disabled: $
}), _ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: i,
  default: i,
  Link: d
}, Symbol.toStringTag, { value: "Module" }));
export {
  i as Button,
  d as Link,
  _ as index
};
